import styled from 'styled-components';
import { breakpoints } from '../../styles/breakpoints';

const PlaybackStartingActions = styled.div`
	display: flex;
	overflow: hidden;
	flex-direction: column;
	margin-top: 8px;

	> {
		flex: 1;
	}

	@media ${breakpoints.sm} {
		flex-direction: row;
		margin-top: 10px;
	}

	@media ${breakpoints.md} {
		margin-top: 14px;
	}
`;

export default PlaybackStartingActions;
